export default __webpack_public_path__ + "static/char-s-35-ja-4654ee44244d6a402c5a30f63a300fde.webp";